export default {
    STANDBY: '',
    LOADING: 'loading',
    SAVING: 'saving',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    FETCHING: 'fetching',
    PENDING: 'pending',
    GENERATING: 'generating',
};
